import React, { useEffect, useState } from 'react';
import {
  EVENTS_TO_ELECTRON,
  INPUT_FIELD_ERROR_MSG,
  PAGE_ROUTE,
  UBA_EVENT_NAME,
} from '../../util/constant';
import { ctaClick, initTracking, pageView } from '../../util/trackingUtils';
import Header from '../Header';
import './testAccessUrlInput.scss';

const TestAccessUrlInput = () => {
  const [url, setUrl] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const ubaPayload = {
      pageName: PAGE_ROUTE.TEST_ROUTE,
    };
    initTracking(ubaPayload, {});
    pageView({}, UBA_EVENT_NAME.proctoringTracker);
  }, []);

  const handleOpenTest = () => {
    setError('');

    try {
      const enteredUrl = new URL(url);
      const currentHost = window.location.hostname;

      if (!enteredUrl.hostname.includes(currentHost)) {
        setError(INPUT_FIELD_ERROR_MSG);
        return;
      }

      ctaClick({
        eventName: UBA_EVENT_NAME.proctoringTracker,
        payload: {
          label: 'Open test',
          cta: 'Open test',
          source: url,
        },
      });

      if (window.electron) {
        const { sendMsgToElectron } = window.electron;
        sendMsgToElectron(EVENTS_TO_ELECTRON.SET_TEST_URL, { url });
      }
    } catch (e) {
      setError(INPUT_FIELD_ERROR_MSG);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleOpenTest();
    }
  };

  return (
    <>
      <Header />
      <div className="input-container">
        <input
          type="text"
          placeholder="Paste test access url here...."
          value={url}
          onChange={(e) => setUrl(e?.target?.value)}
          onKeyPress={handleKeyPress}
          className="input-box"
        />
        <button type="button" onClick={handleOpenTest} className="open-button">
          Open Test
        </button>
      </div>
      {error && <div className="input-container error-message">{error}</div>}
      <ul className="input-container" style={{ top: error ? '58%' : '55%' }}>
        <li>
          Copy the access link in the email using Ctrl+C (Cmd+C on Mac). Don
          &apos;t right-click copy, as email clients like Outlook and Gmail may
          alter it.
        </li>
      </ul>
    </>
  );
};

export default TestAccessUrlInput;
